import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { changeSearchTab, receivedSearchTabs } from './actions';
import SearchTab, { AI_TAB_TITLE } from './search_tab';

const SearchTabs = ({ context }) => {
  const [searchTabs, setSearchTabs] = useState();
  const [activeTabId, setActiveTabId] = useState();

  const paramStore = context.getStore('ParamStore');

  const setActiveTab = () => {
    if (searchTabs) {
      const searchTabParamId = paramStore.get('search_tab_id');
      if (searchTabParamId) {
        setActiveTabId(+searchTabParamId);
      } else {
        const aiToolParam = new URLSearchParams(window.location.search).get('ai_tool');
        if (aiToolParam) {
          const aiTab = searchTabs.find(tab => tab.title === AI_TAB_TITLE);
          if (aiTab) {
            setActiveTabId(aiTab.id);
            return;
          }
        }
        setActiveTabId(searchTabs.find(tab => tab.default).id);
      }
    }
  };

  useEffect(() => {
    const fetchSearchTabs = async () => {
      const response = await fetch(window.LP.config.search_tabs_path);
      const data = await response.json();
      let formattedData = data.map((tab) => {
        const unsupportedParams = tab.unsupported_facet_frontend_keys;
        const defaultTypeIds = tab.default_type_ids;
        delete tab.unsupported_facet_frontend_keys;
        delete tab.default_type_ids;
        return { ...tab, unsupportedParams, defaultTypeIds };
      });
      if (!window.LP.config.ai_enabled) {
        formattedData = formattedData.filter(tab => tab.title != AI_TAB_TITLE);
      }
      setSearchTabs(formattedData);
    };

    fetchSearchTabs();

    return () => {
      paramStore.removeChangeListener(setActiveTab);
    };
  }, []);

  useEffect(() => {
    if (searchTabs) {
      paramStore.addChangeListener(setActiveTab);
      setActiveTab();
      context.executeAction(receivedSearchTabs, searchTabs);
    }
  }, [searchTabs]);

  if (!searchTabs) return null;

  const clickHandler = (tab) => {
    context.executeAction(changeSearchTab, { ...tab, previousTabId: activeTabId });
  };

  return (
    <>
      {searchTabs.map((searchTab) => {
        const { id } = searchTab;
        searchTab.isActive = activeTabId === id;

        return <SearchTab key={id} {...searchTab} onClick={clickHandler} />;
      })}
    </>
  );
};

SearchTabs.propTypes = {
  context: PropTypes.object
};

export default SearchTabs;
